export default __webpack_public_path__ + "static/media/linkedin-svgrepo-com.da93b052.svg";